import { connect } from 'react-redux';

import { loadUsersPartnerPartnership } from '../../../../../state/modules/users/actions';
import UserPartnerPartnershipInput from '../components/UserPartnerPartnershipInput';

const mapStateToProps = (state) => {
  return {
    total: state.users.get('total'),
    isLoading: state.users.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(loadUsersPartnerPartnership(partnershipId, page, limit, order, filter, cb));
    },
  };
};

const UserPartnerPartnershipInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserPartnerPartnershipInput);

export default UserPartnerPartnershipInputContainer;
